import { observable, computed } from "mobx";
import { Content, SectionQuiz, SavedSection, SavedFinalQuiz, SectionFinalQuiz } from "../types";
import { findItemAndIndexById } from "../utils";

export interface AppState {
  content: Content;
  completedSectionIds: string[];
  lockedSectionIds: string[];
  alreadySeenResourceIds: string[];
}

export default class Store {
  constructor(initialState: AppState) {
    this.content = initialState.content;
    this.completedSectionIds = initialState.completedSectionIds;
    this.lockedSectionIds = initialState.lockedSectionIds;
    this.alreadySeenResourceIds = initialState.alreadySeenResourceIds;
  }
  @observable
  content: Content;

  @observable
  completedSectionIds: string[];

  @observable
  lockedSectionIds: string[];

  @observable
  alreadySeenResourceIds: string[];

  @observable
  savedSections: { [key: string]: SavedSection } = {};

  @observable
  savedFinalQuiz: SavedFinalQuiz = {
    questionList: [],
  };

  @computed
  get finalQuiz() {
    return this.content.sections.find((sec) => sec.type === "finalQuiz") as SectionFinalQuiz;
  }

  @computed
  get finalQuizStartingIndex() {
    return Math.min(this.savedFinalQuiz.questionList.length, this.finalQuiz.quiz.questionList.length - 1);
  }

  @observable
  completionStatus: "completed" | "incomplete" | "not attempted" | "unknown" = "not attempted";

  @computed
  get quizSectionList() {
    return this.content.sections.filter<SectionQuiz>((section): section is SectionQuiz => section.type === "quiz");
  }

  getSection = (idSection: string) => {
    return findItemAndIndexById(idSection, this.content.sections);
  };
}
